import React, { useState } from 'react';

import { Button } from '_lib/components/Button/Button';
import { DialogActions } from '_lib/components/DialogActions/DialogActions';
import { DialogContent } from '_lib/components/DialogContent/DialogContent';
import { DialogContentText } from '_lib/components/DialogContentText/DialogContentText';
import { PhoneNumberTextField } from '_lib/components/PhoneNumberTextField/PhoneNumberTextField';
import { Stack } from '_lib/components/Stack/Stack';
import { DialogWrapper } from '_lib/featureComponents/DialogWrapper/DialogWrapper';
import { isValidPhone10 } from '_lib/utils/helpers';

interface InvalidCallerIdDialogProps {
  invalidCallerId: string | undefined;
  open: boolean;
  onClose: (callerId: string) => void;
}

export const InvalidCallerIdDialog = (props: InvalidCallerIdDialogProps): React.ReactElement => {
  const { invalidCallerId, open, onClose } = props;
  const [callerId, setCallerId] = useState('');

  const callerIdIsValid = isValidPhone10(callerId);

  return (
    <DialogWrapper titleText='Invalid Caller ID' dismissable={false} open={open} onClose={() => {}}>
      <DialogContent>
        <Stack spacing={2}>
          <DialogContentText>
            {`Call was initiated with an invalid Caller ID: ${invalidCallerId || 'EMPTY'}`}
          </DialogContentText>
          <DialogContentText>{`Set Caller ID to continue.`}</DialogContentText>
          <PhoneNumberTextField
            // only display "as error" if callerId is non empty AND invalid
            error={!!callerId && !callerIdIsValid}
            label='Caller ID'
            required
            value={callerId}
            onChange={(e) => setCallerId(e.target.value)}
            onEnter={(_) => (callerIdIsValid ? onClose(callerId) : undefined)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          sx={{ textTransform: 'none' }}
          disabled={!callerIdIsValid}
          text={'Done'}
          onClick={() => onClose(callerId)}
        />
      </DialogActions>
    </DialogWrapper>
  );
};
